import Navbar from "../components/Navbar";
import Hero from "../components/landing/Hero";
import About from "../components/landing/About";
import Features from "../components/landing/Features";
import HowItWorks from "../components/landing/HowItWorks";
import Architecture from "../components/landing/Architecture";
import DashboardPreview from "../components/landing/DashboardPreview";
import Performance from "../components/landing/Performance";
import FutureScope from "../components/landing/FutureScope";
import DemoSection from "../components/landing/DemoSection";
import Footer from "../components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar transparent />
      <main>
        <Hero />
        <About />
        <Features />
        <HowItWorks />
        <Architecture />
        <DashboardPreview />
        <Performance />
        <DemoSection />
        <FutureScope />
      </main>
      <Footer />
    </div>
  );
}
